module.exports = __webpack_public_path__ + "img/pnk.9cc3eaf5.svg";